<h2 mat-dialog-title class="mb-1 fs-3">NauTopsy jelszó visszaállítás</h2>
<button type="button" mat-icon-button (click)="onClose()" class="close-btn">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <p class="mb-4">Kérjük, adja meg felhasználónevét!</p>

  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
    <div class="mb-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Felhasználónév</mat-label>
        <input
          matInput
          type="text"
          [formControl]="forgotPasswordForm.controls.usernameOrEmail"
          placeholder="Adja meg felhasználónevét"
        />
        @if (forgotPasswordForm.controls.usernameOrEmail.hasError('required') &&
        forgotPasswordForm.controls.usernameOrEmail.touched) {
        <mat-error class="text-danger">A mező kitöltése kötelező!</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" (click)="onClose()" class="btn btn-outline-primary">Mégse</button>
  <button
    type="submit"
    (click)="onSubmit()"
    [disabled]="forgotPasswordForm.invalid || isLoading()"
    class="btn btn-primary"
  >
    @if (isLoading()) {
      <mat-spinner diameter="20" class="me-2" style="display: inline-block;"></mat-spinner>
    }
    Új jelszó kérése
  </button>
</mat-dialog-actions>
